import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  prefix: 'c-',
})
